import PubSub from "pubsub-js";

PubSub.subscribe("dataLayer", function(channel, message) {
	if (window.dataLayer) {
		window.dataLayer.push(message);
	}
});